import { useEffect } from "react";
import { createMicroConversionTrackingUtils } from "..";
import useProfiler from "../../../hooks/useProfiler";
import { useSelector } from "react-redux";
import { getExtraProducts } from "../../../ancillaries/store/extraProducts/selectors";
import useIsBrandedFare from "../../../branded-fares/hooks/useIsBrandedFare";
import { UIFlightData } from "@flights/types";

const utils = createMicroConversionTrackingUtils({
  name: "flights_web_condensed_extras_fd_ddot",
  stages: {
    fd: 1, // dummy stage
    fetchedFD: 2, // fully fetched flight details (fallback)
    sawExtras: 3, // FD where users see baggage and/or extras
    direct: 4,
    meta: 5,
    oneWay: 6,
    roundTrip: 7,
    brandedFare: 8,
    geniusDiscount: 9
  },
  defaultStage: 1,
  mainStage: 2,
  goals: {},
  goalsWithValue: []
});

const useTrackStages = (isInViewport: boolean, flight: UIFlightData) => {
  const stages = utils.stages;
  const { isDirect, isOneWay, isRountrip } = useProfiler();
  const isBrandedFare = useIsBrandedFare();
  const extraProducts = useSelector(getExtraProducts);
  const hasGeniusDiscount =
    flight.priceBreakdown?.bcomPricingItems?.some(
      (item) => item.itemType === "GENIUS_DEAL" || item.itemType === "GENIUS_AIRLINE_FARE"
    ) ||
    flight.ancillaries?.checkedInBaggage?.options[0]?.priceBreakdown?.bcomPricingItems?.some(
      (item) => item.itemType === "GENIUS_CHECKED_BAG"
    ) ||
    flight.ancillaries?.flexibleTicket?.priceBreakdown?.bcomPricingItems?.some(
      (item) => item.itemType === "GENIUS_FLEXTICKET"
    );

  useEffect(() => {
    if (!extraProducts || !isInViewport) {
      return;
    }

    stages.sawExtras();
    isDirect() ? stages.direct() : stages.meta();
    isOneWay() && stages.oneWay();
    isRountrip() && stages.roundTrip();
    isBrandedFare && stages.brandedFare();
    hasGeniusDiscount && stages.geniusDiscount();
  }, [isDirect, isOneWay, isRountrip, isBrandedFare, hasGeniusDiscount, stages, isInViewport, extraProducts]);
};
export default { ...utils, useTrackStages };
